const phonemeSerializer = ((node, children) => {
  return `<phoneme alphabet="${node.alphabet}" ph="${node.ph}">${children}</phoneme>`;
});

export { phonemeSerializer };
//# sourceMappingURL=serializer.js.map
